module.exports = __webpack_public_path__ + "img/controlled_medicine.bf011592.svg";